fourToldApp.controller("verificationCntrl", function($scope, services, $window, $mdDialog, $interval, $location, productService, countries, theme, $controller) {
	window.onpopstate = function (e) {window.history.forward(1); }
	var promise;
	$scope.verificationUser = undefined;
	$scope.sms_verification = {};
	$scope.dial_codes = countries;
	$scope.phonePrefix = $window.sessionStorage.getItem("prefix");
	$scope.phoneNumber = parseInt($window.sessionStorage.getItem("phoneNumber"));
	$scope.theme = theme.getTheme();
	$scope.showLogoHeader = true;
	if($window.sessionStorage.getItem('isAgentWebView') === "true"){
		$scope.showLogoHeader = false;
	}

 	$scope.start = function() {
		$scope.mode = 'query';
		$scope.activated = true;
		$scope.determinateValue = 0;
		$scope.showList = [];
		$scope.counter = 300;
 	  $scope.stop();
 	  promise = $interval(function() {
 	      $scope.determinateValue += 1;
 					if($scope.counter !== 0){
 		 			 var counter = $scope.counter--;
 		 		 } else $scope.resendSms = true;
 	 }, 1000, 0, true);

 	};

 	$scope.stop = function() {
 	  $interval.cancel(promise);
 	};

 	$scope.start();

	$scope.submitVerificationCode = function(){
		$scope.stop();
		$scope.progressCircular = "ok";
		$scope.verificationUser.userId = parseInt($window.sessionStorage.getItem("userID"));
		$scope.verificationUser.userName = 	$scope.phonePrefix + $scope.phoneNumber;

		if (window.sessionStorage.getItem('phoneNumber'))
			window.sessionStorage.setItem('phoneNumber',$scope.phoneNumber);
		
		services.verification().code({}, $scope.verificationUser,  function(response) {
				if(response.code === 1){
					productService.addProduct(3);

					if($window.navigator.userAgent=== 'commerce-mobile' && $location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
					&& $location.search().user_teller_agent!='undefined'){
						$controller('loginCntrl', {
							$scope: $scope
					});
				 
					$scope.submitTag(true, $window.sessionStorage.getItem('registerTag'));

					}
					else{
						var activatedConfigureQuestions = $window.sessionStorage.getItem('activatedConfigureQuestions') === "true";
						if(activatedConfigureQuestions === true) {
							$location.path("/quentions");
						} else {
							$controller('loginCntrl', {
								$scope: $scope
							});
						 
							$scope.submitTag(true, $window.sessionStorage.getItem('registerTag'));
	
						
						}
						
					}
					
				/*$controller('loginCntrl', {
							$scope: $scope
					});
					$scope.submit();*/
				} else if (response.code === -3){
						$scope.progressCircular = undefined;
						$scope.showAlert("Código inválido, por favor intente de nuevo");
				} else if(response.code === -500){
						$scope.progressCircular = undefined;
						$scope.showAlert("Ocurrio un error en el proceso, intente de nuevo. De continuar el problema, contactar a soporte técnico");
				}
		});
	}

	$scope.smsVerification = function(){
		$scope.progressCircular = "ok";
		$scope.sms_verification.userId = parseInt($window.sessionStorage.getItem("userID"));
		$scope.sms_verification.newPhonePrefix = $scope.phonePrefix;
		$scope.sms_verification.newPhoneNumber = $scope.phoneNumber.toString();
		$scope.sms_verification.newCountryCode =  $window.sessionStorage.getItem("countryCode");
		services.verification().sms_verification({}, $scope.sms_verification,  function(response) {
				$scope.progressCircular = undefined;
				if(response.code ===1){
					$scope.resendSms = false;
					$scope.start();
					$scope.showAlert("Código enviado exitosamente al número de teléfono.");
				} else $scope.showAlert("Ocurrió un problema durante el proceso, contacte a soporte ténico.");
		});
	};

	$scope.showAlert = function( message) {
		$mdDialog.show(
			$mdDialog.alert()
				.parent(angular.element(document.querySelector('#popupContainer')))
				.clickOutsideToClose(true)
				.title('Notificación')
				.textContent(message)
				.ariaLabel('Alert Dialog Demo')
				.ok('Ok')
		);
	};
});
